import { useTRPC } from "../../trpc";
import { Button, Stack, Text, Title } from "@mantine/core";
import { useCallback } from "react";
import { RelativeLink } from "../../components/Link";
import { FullPageLoader } from "../../components/FullPageLoader";
import { FormattedMessage } from "react-intl";
import { captureEvent } from "../../utils/posthog";
import { useMutation } from "@tanstack/react-query";
import { Event } from "../../constants/events";

export function RequestEmailVerification() {
  const trpc = useTRPC();

  const {
    mutate,
    isPending,
    isSuccess,
  } = useMutation(trpc.requestVerificationEmail.mutationOptions());

  const handleClick = useCallback(() => {
    captureEvent(Event.AuthRequestVerificationEmail);
    mutate();
  }, [mutate]);

  if (isPending) {
    return (
      <FullPageLoader />
    );
  }

  return (
    <Stack>
      {!isSuccess && (
        <>
          <Title size="h2">
            <FormattedMessage id="title.notVerified" defaultMessage="Email is not verified!" />
          </Title>
          <Text>
            <FormattedMessage
              id="text.notVerified"
              defaultMessage="To use services, please verify your email address. Request a new verification email below."
            />
          </Text>
          <Button onClick={handleClick} variant="primary">
            <FormattedMessage
              id="button.requestVerificationEmail"
              defaultMessage="Request verification email"
            />
          </Button>
        </>
      )}
      {isSuccess && (
        <>
          <Title size="h2">
            <FormattedMessage id="title.verificationSent" defaultMessage="Email verification sent" />
          </Title>
          <Text>
            <FormattedMessage
              id="text.verificationSent"
              defaultMessage="We have sent you an email with a link to verify your email address. If you do not get an email please check your spam folder."
            />
          </Text>
          <RelativeLink href="../sign-in" onClick={() => { captureEvent(Event.AuthNavigateToSignIn); }}>
            <FormattedMessage id="link.returnToSignIn" defaultMessage="Return to sign in" />
          </RelativeLink>
        </>
      )}
    </Stack>
  );
}
